import { RootState } from '../store/store';

export const saveToLocalStorage = (state: RootState) => {
  try {
    // #28: НЕ зберігаємо токени в localStorage. JWT — лише в пам'яті, refresh — httpOnly cookie.
    const sanitized = {
      ...state,
      auth: { ...state.auth, jwtToken: null, refreshToken: null },
    };
    const serializedState = JSON.stringify(sanitized);
    localStorage.setItem('reduxState', serializedState);
  } catch (e) {
    console.warn('Не удалось сохранить состояние в localStorage', e);
  }
};

export const loadFromLocalStorage = () => {
  try {
    const serializedState = localStorage.getItem('reduxState');
    if (serializedState === null) return undefined;
    return JSON.parse(serializedState);
  } catch (e) {
    console.warn('Не удалось загрузить состояние из localStorage', e);
    return undefined;
  }
};
